<ion-list lines="none">
  <ion-item (click)="backToDashboard()" button="true">
    <ion-icon src="/assets/icons/24px/line-arrow-left.svg" slot="start"> </ion-icon>

    <ion-label> Back to Dashboard </ion-label>
  </ion-item>

  <ion-item (click)="editInDescript()" button="true">
    <ion-icon src="/assets/icons/24px/descript.svg" slot="start"> </ion-icon>

    <ion-label> Edit in Descript </ion-label>
  </ion-item>
</ion-list>
